var React = require('react');

function CommentIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 0C8.27 0 2 6.27 2 14a13.95 13.95 0 004.043 9.828L6 32l6.703-4.434c1.063.262 2.156.434 3.297.434 7.73 0 14-6.27 14-14S23.73 0 16 0z","fill":"#fff"}));
}

CommentIcon.defaultProps = {"viewBox":"0 0 32 32","fill":"#fff"};

module.exports = CommentIcon;

CommentIcon.default = CommentIcon;
